import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const tooltipTemplate = (
  stylecontext: string,
  node: HTMLElement,
) => html`<tef-coms-tooltip cloak context="${stylecontext}" placement="bottom">
  ${unsafeHTML(node.innerHTML)}
  <div slot="content">
    ${unsafeHTML(node.title)}
  </div>
</tef-coms-tooltip>`;
